<template>
	<div>
		<div class="row">
			<div class="col">
				<h1>
					Edit a news item
				</h1>
			</div>

			<div class="col-auto">
				<locale-switcher @change="fetchAgain" />
			</div>
		</div>

		<form class="mt-4" @submit.prevent="updateNews">
			<div class="form-group">
				<label for="title">
					<small class="text-muted">TITLE</small>
				</label>
				<input type="text" class="form-control" name="title" placeholder="Title" v-model="title" :disabled="loading" required autofocus>
			</div>

			<div class="form-group">
				<label>
					<small class="text-muted">CONTENT</small>
				</label>
				<quill-editor v-model="content" :options="quillOptions" :disabled="loading" />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGE</small>
				</label>
				<file-input @change="setImage" placeholder="Do not select to keep current" :disabled="loading" />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGES</small>
				</label>
				<file-input @change="files => images = files" multiple placeholder="Choose images (replace old if set)" />
			</div>

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Saving…' : 'Save' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>

<script>
	import {getError} from '../../../helpers';
	import store from '../../../store';
	import FileInput from '../../FileInput';

	import LocaleSwitcher from '../../LocaleSwitcher';

	export default {
		components: {
			'locale-switcher': LocaleSwitcher,
			'file-input': FileInput,
		},

		async beforeRouteEnter(to, from, next) {
			const news = await store.dispatch('news/fetch', {
				newsId: to.params.id,
			});

			next(vm => {
				vm.title = news.title;
				vm.content = news.content;
			});
		},

		data() {
			return {
				title: '',
				content: '',
				image: null,
				images: [],

				quillOptions: {
					placeholder: 'Insert a description...',
				},
				
				loading: false,
				error: '',
			};
		},
		
		methods: {
			updateNews() {
				this.loading = true;

				return this.$store.dispatch('news/update', {
					newsId: this.$route.params.id,
					title: this.title,
					content: this.content,
					image: this.image,
					images: this.images
				}).then(news => {
					this.$router.push({name: 'view-news', params: {
						id: news.id,
					}});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
			},

			async fetchAgain({oldValue}) {
				this.loading = true;

				this.$store.dispatch('news/update', {
					newsId: this.$route.params.id,
					title: this.title,
					content: this.content,
					image: this.image,
					images: this.images
				}).then(async () => {
					const news = await this.$store.dispatch('news/fetch', {
						newsId: this.$route.params.id,
					});

					this.title = news.title;
					this.content = news.content;
				}).catch(e => {
					this.$store.dispatch('setContentLocale', oldValue);
					this.error = getError(e);
				}).finally(() => {
					this.loading = false;
				});
			},

			setImage(files) {
				this.image = files[0];
			}
		},

		meta: {
			title: 'Edit a news item',

			meta: [
				{property: 'og:title', content: 'Edit a news item / Al-Shayah'},
			],
		},
	};
</script>
